// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:50
import { CrewTask_abstract } from './../abstract/SagaSchema/CrewTask_abstract';
export class CrewTask extends CrewTask_abstract {}
